import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { useTransactions } from "../../context/TransactionsContext";

import Transaction from "./Transaction";

const Transactions: FC = () => {
  const { t } = useTranslation("transactions");
  const { state } = useTransactions();
  return (
    <div id="transactions-container" className="my-transactions__transactions">
      <div className="my-transactions__transactions-top">
        <span>{t("description")}</span>
        <span>{t("qualifiedPoints")}</span>
        <span>{t("voebizPoints")}</span>
      </div>

      {state.transactions.map((transaction) => (
        <Transaction key={transaction.id} {...transaction} />
      ))}
    </div>
  );
};

export default Transactions;
